module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "con"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/dedication#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_Gen"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/disclaimer#Gen"
    }
  }, [_vm._v("General Disclaimer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("I: Understanding the Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("What Is Aging?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Medicine’s Role in Life Extension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aging’s Effects on Your Dog’s Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("II: Understanding the Plan: Step-by-Step Explanations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1. Stay in Touch with Your Dog’s Health")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2. Ensure Exercise, Grooming, and Dental Hygiene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3. Create a Safe, Healthy Home Environment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 4. Avoid Behavioral Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 5. Optimize Nutrition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 6. Manage and Improve Your Dog’s Internal Processes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_pt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("III: Seeing the Big Picture")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plan: A Sample Year in the Life of Your Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Therapies for Common Age-Related Disorders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Time for Letting Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot",
    attrs: {
      "id": "c_Con"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#Con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_App1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix1#App1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix1#App1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Canine First Aid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_App2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix2#App2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: The In-Home Canine Pharmacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_App3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix3#App3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Toxic Substances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_App4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix4#App4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: Health Maintenance Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_ad"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Martin’s Press Titles by John M. Simon, D.V.M. (with Stephanie Pederson)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c_Abo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#Abo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0